/** Klikatelne strany v stratup faze */
export enum StartupClickSides {
  left = -1,
  right = 1,
  none = 0
}
